// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'
import '@fancyapps/fancybox'
import 'slick-carousel'
import 'mapbox-gl'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import templateEspaceDelegue from './routes/templateEspaceDelegue';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Espace délégué
  templateEspaceDelegue,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js